import Table from "@/common/elements/Table";
import {
  InmateDetailsTableContainer,
  TableHeader,
} from "../InmateDetails/styles";
import Button from "@/common/elements/Button";
import { StyledFlex, StyledTypographyText } from "@/common/styles";
import { useEffect, useState } from "react";
import CustomModal from "../CustomModal";
import BailRecordDetailForm from "./BailRecordDetailForm";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidV4 } from "uuid";
import {
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form, Popconfirm } from "antd";
import dayjs from "dayjs";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import _ from "lodash";
import API_ENDPOINTS from "@/util/api";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const ChargesBailRecordsDetails = ({}) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [bookingBails, setBookingBails] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [totalUnpaidBill, setTotalUnpaidBill] = useState(0);
  const [selectBail, setSelectBail] = useState(null);
  const [isEdit, setisEdit] = useState(false);

  useEffect(() => {
    if (bookings !== null) {
      const bookingBails = [];
      let totalUnpaidBill = 0;
      console.log(bookings?.bookingBails);

      bookings?.bookingBails?.forEach((element, index) => {
        if (!element?.paid) {
          if (isNonEmptyVariable(element?.bailAmount)) {
            totalUnpaidBill += parseFloat(element?.bailAmount);
          }
        }
        bookingBails.push({
          ...element,
          id: index + 1,
          bookingBailUuid: element?.bookingBailUuid || uuidV4(),
          bailType: isNonEmptyVariable(element?.bailTypeID)
            ? getRefListNameByID("BondType", element?.bailTypeID)
            : "",
          paidLabel:
            isNonEmptyVariable(element?.paid) && element?.paid
              ? "True"
              : "False",
        });
      });
      setTotalUnpaidBill(() => totalUnpaidBill);
      setBookingBails(() => bookingBails);
    }
  }, [bookings]);

  const handleModalVisble = () => {
    setIsModalVisible(!isModalVisible);
  };

  const modifyBailDetailsAction = () => {
    form.validateFields().then((v) => {
      const updateBookingBails = bookingBails?.map((bb) => {
        if (
          (isNonEmptyVariable(bb?.bookingBailID) &&
            bb?.bookingBailID === selectBail?.bookingBailID) ||
          bb?.bookingBailUuid === selectBail?.bookingBailUuid
        ) {
          console.log(bb);
          return {
            ...bb,
            ...v,
            offBondDate: isNonEmptyVariable(v?.offBondDate)
              ? dayjs(v?.offBondDate)?.format("MM/DD/YYYY")
              : null,
          };
        }
        return bb;
      });

      dispatch(
        setBookings({
          bookingBails: updateBookingBails,
        })
      );

      cancelAction();
    });
  };

  const onRowClick = (data) => {
    setSelectBail(data);
    setisEdit(() => true);
  };

  const cancelAction = () => {
    setSelectBail(null);
    setisEdit(() => false);
    setIsModalVisible(() => false);
  };

  const deleteBail = () => {
    let data = _.cloneDeep(bookingBails);
    data = data?.filter((d) => {
      return d?.bookingBailUuid !== selectBail?.bookingBailUuid;
    });

    let bookingCharges = bookings.charges.map((charge) => {
      const bail = charge.bookingBails?.[0];
      return {
        ...charge,
        bookingBails:
          bail?.bookingBailID === selectBail?.bookingBailID ? [] : bail,
      };
    });

    dispatch(
      setBookings({
        charges: bookingCharges,
        bookingBails: data,
      })
    );

    const url = API_ENDPOINTS.bookingBails + "/id/" + selectBail?.bookingBailID;
    dispatch(setDeleteAPis(url));
    cancelAction();
  };

  return (
    <>
      <InmateDetailsTableContainer>
        <TableHeader>
          <h6>List of Bail Records</h6>
          <div className="right">
            {
              <Button
                onClick={handleModalVisble}
                disabled={
                  !isEdit ||
                  !hasCheckSecurity(
                    Security_Types.functionality,
                    Entity_types.subModule,
                    LABELS_CAPITAL.VIEW,
                    MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                    SUB_MODULES_LIST_WITH_ID.Arrest_Report
                  )
                }
              >
                Details
              </Button>
            }

            {
              <Popconfirm
                title="Delete the Bail"
                description="Are you sure to delete this bail record?"
                onConfirm={deleteBail}
                onCancel={() => {}}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  style={{ marginLeft: "10px" }}
                  color="primary"
                  type="primary"
                  disabled={
                    !isEdit ||
                    !bookingsFieldsEnabled ||
                    !hasCheckSecurity(
                      Security_Types.functionality,
                      Entity_types.subModule,
                      LABELS_CAPITAL.DELETE,
                      MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                      SUB_MODULES_LIST_WITH_ID.Arrest_Report
                    )
                  }
                >
                  DELETE
                </Button>
              </Popconfirm>
            }
            <Button
              style={{ marginLeft: "10px" }}
              disabled={!isEdit}
              onClick={cancelAction}
            >
              Cancel
            </Button>
          </div>
        </TableHeader>

        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={[
              { key: "id", text: "ID" },
              { key: "dateAdded", text: "Date Added" },
              { key: "timeAdded", text: "Time Added" },
              { key: "bailAmount", text: "Bail Amount" },
              { key: "courtNumber", text: "Court #" },
              { key: "bailType", text: "Bail Type" },
              { key: "paidLabel", text: "Satisfied" },
              { key: "comments", text: "Comments" },
            ]}
            data={bookingBails}
            // variant="outlined"
            onRowClick={onRowClick}
            selected={selectBail === null}
          />
        )}
        <StyledFlex justify="end">
          <StyledTypographyText
            textTransform="capitalize"
            fontSize="15px"
            color="#000"
          >
            Total Unpaid Bail: <span>{totalUnpaidBill}</span>
          </StyledTypographyText>
        </StyledFlex>
      </InmateDetailsTableContainer>

      {isModalVisible && (
        <CustomModal
          show={isModalVisible}
          onHide={handleModalVisble}
          size="xl"
          header="Bail Details"
          onSaveClick={modifyBailDetailsAction}
          isDisabled={
            !bookingsFieldsEnabled ||
            hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.MODIFY,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report
          )}
        >
          <BailRecordDetailForm form={form} formData={selectBail} />
        </CustomModal>
      )}
    </>
  );
};
export default ChargesBailRecordsDetails;
